import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../static/icons/pen_icon.svg'


const _hoisted_1 = { class: "decoration-summary" }
const _hoisted_2 = { class: "decoration-summary__title" }
const _hoisted_3 = { class: "decoration-summary-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "decoration-summary__description" }
const _hoisted_6 = { class: "decoration-summary__texts" }
const _hoisted_7 = { class: "decoration-summary__placement" }
const _hoisted_8 = { class: "decoration-summary__technique" }

import { inject, computed } from 'vue';
import { injectionKeys as litiumKeys } from '@motillo/drapejs-litium';
import { configuratorStateKey } from '../ProductConfiguratorKeys';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

export default /*@__PURE__*/_defineComponent({
  __name: 'DecorationSummary',
  props: {
  placements: {
    type: Array,
    required: true,
  },
},
  emits: ['edit'],
  setup(__props, { emit: __emit }) {

const { configuratorState } = inject(configuratorStateKey);
const emit = __emit;
const toLitiumMediaUrl = inject(litiumKeys.toLitiumMediaUrlKey, () => '');
const { websiteText } = useWebsiteTexts();

const props = __props;

const imageSource = computed(() => {
  const id = configuratorState.value.selections.fileUpload.systemId;
  return toLitiumMediaUrl(id, { maxWidth: 124 });
});

function getSelectedPlacementData() {
  return props.placements.find(p => {
    return p.systemId === configuratorState.value.selections.selectedPlacement;
  });
}

const selectedPlacementText = computed(() => {
  const placement = getSelectedPlacementData();
  return `${websiteText('decoration__placement').value}: ${placement.position.name || placement.position.value}`;
});

const selectedTechniqueText = computed(() => {
  const placement = getSelectedPlacementData();
  const technique = placement.techniques
    .find(t => t.systemId === configuratorState.value.selections.selectedTechnique);
  return `${websiteText('decoration__technique').value}: 
    ${technique.name || websiteText(`decoration__technique_${technique.code.toLowerCase()}`).value}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(websiteText)('decoration__added_decoration').value), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        class: "decoration-summary__image",
        src: imageSource.value,
        alt: "Decoration image"
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "secondary-button decoration-summary__edit-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('edit', 'pickTechnique')))
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            src: _imports_0,
            alt: "upload-icon"
          }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(websiteText)('global__edit').value), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(selectedPlacementText.value), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(selectedTechniqueText.value), 1)
        ])
      ])
    ])
  ]))
}
}

})